module.exports = __webpack_public_path__ + "static/media/spinner.efeed92d.gif";